import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";

const SlideShow = (props) => {
  const { height, width } = useWindowDimensions();
  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
  };
  return (
    <Carousel {...settings}>
      <Wrap className="">
        <div
          style={{
            width: width > 768 ? "59%" : "100%",
            marginLeft: width > 768 ? "320px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-xl lg:text-2xl p-10 pb-0 lg:px-20 flex items-center lg:leading-14 h3class">
            An Internship provides you with firsthand experience, professional
            opportunities and personal growth.
          </h3>
          <div className="banner right-0 slideshow_banner">
            <img
              className=""
              src="/internSlide/Internship1.jpg"
              alt=""
              style={{
                // height: width > 768 ? "200px" : "100px",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
      <Wrap className="">
        <div
          style={{
            width: width > 768 ? "59%" : "100%",
            marginLeft: width > 768 ? "320px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-xl lg:text-2xl p-10 lg:px-20 flex items-center lg:leading-14 h3class">
            Through internship, explore your career and get real world
            experience.
          </h3>
          <div className="banner slideshow_banner">
            <img
              src="/internSlide/Internship2.jpg"
              alt=""
              style={{
                // height: width > 768 ? "200px" : "100px",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
      <Wrap className="">
        <div
          style={{
            width: width > 768 ? "59%" : "100%",
            marginLeft: width > 768 ? "320px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-2xl lg:text-2xl p-10 lg:px-20 flex items-center lg:leading-14 h3class">
            Internship will have great impact on your career.
          </h3>
          <div className="banner slideshow_banner mb-5">
            <img
              src="/internSlide/Internship3.jpeg"
              alt=""
              style={{
                // height: width > 768 ? "200px" : "100px",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
      <Wrap className="">
        <div
          style={{
            width: width > 768 ? "59%" : "100%",
            marginLeft: width > 768 ? "320px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-2xl lg:text-2xl p-10 pb-0 lg:px-20 flex items-center lg:leading-14 h3class">
            Boost your resume for better jobs & higher salary potential.
          </h3>
          <div className="banner m-5 pt-5 slideshow_banner">
            <img
              src="/internSlide/Internship4.png"
              alt=""
              style={{
                // height: width > 768 ? "200px" : "100px",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
      <Wrap className="">
        <div
          style={{
            width: width > 768 ? "59%" : "100%",
            marginLeft: width > 768 ? "320px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-2xl lg:text-2xl p-10 lg:px-20 flex items-center lg:leading-14 h3class">
            Apply theoretical knowledge in the real world.
          </h3>
          <div className="banner slideshow_banner">
            <img
              src="/internSlide/Internship5.jpg"
              alt=""
              style={{
                // height: width > 768 ? "200px" : "100px",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
    </Carousel>
  );
};

const Carousel = styled(Slider)`
  margin-top: 20px;
  & > button {
    opacity: 0;
    height: 20%;
    width: 1vw;
    z-index: 1;

    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 7px;
      color: rgba(47, 126, 7, 0.832);
    }
  }
  li.slick-active button:before {
    ${"" /* color: '#258480'; */}
  }
  .slick-list {
    overflow: hidden;
  }
  .slick-prev {
    display: none;
  }
  .slick-next {
    display: none;
  }
`;
const Wrap = styled.div``;

export default SlideShow;
